import { Injectable } from "@angular/core";
import { SelectItem } from "primeng/api";
import { ConfiguracaoAgendaEmpresa } from "src/app/admihair/api/dto/configuracao-agenda-empresa";
import { ConfiguracaoAgendaProfissional } from "src/app/admihair/api/dto/configuracao-agenda-profissional";
import { Profissional } from "src/app/admihair/api/dto/profissional";

@Injectable()
export class AgendaRecursosService {

  

  buildResources(dataSelecionada: Date,configuracoesProfissionais: ConfiguracaoAgendaProfissional[]): any[] {
    const diaSemana = dataSelecionada.getDay() + 1;
    return configuracoesProfissionais
      .filter(conf => conf.diaSemanaId === diaSemana)
      .map(conf => ({
        id: conf.profissional?.id,
        title: conf.profissional?.nomeProfissional,
        agendamentos: 0
      }));
  }

  processarListaProfissionais(
    configuracoesProfissionais: ConfiguracaoAgendaProfissional[]
  ): Profissional[] {
    const map = new Map<number, Profissional>();
    for (const item of configuracoesProfissionais) {
      if (item.profissional?.id) {
        map.set(item.profissional.id, item.profissional);
      }
    }
    return Array.from(map.values());
  }

  buildSelectProfissionaisBloqueio(
    configuracoesProfissionais: ConfiguracaoAgendaProfissional[]
  ): SelectItem[] {
    const map = new Map<number, SelectItem>();
    map.set(0, { label: 'TODOS', value: null });

    configuracoesProfissionais.forEach(item => {
      const prof = item.profissional;
      if (prof?.id && !map.has(prof.id)) {
        map.set(prof.id, { label: prof.nomeProfissional, value: prof });
      }
    });

    return Array.from(map.values());
  }

  existeConfiguracaoParaDia(
    diaSemana: number,
    configuracoes: ConfiguracaoAgendaEmpresa[]
  ): boolean {
    return configuracoes.some(conf => conf.diaSemanaId === diaSemana);
  }

  existeProfissionalDisponivel(
    diaSemana: number,
    configuracoesProfissionais: ConfiguracaoAgendaProfissional[]
  ): boolean {
    return configuracoesProfissionais.some(conf => conf.diaSemanaId === diaSemana);
  }
}